// extracted by mini-css-extract-plugin
module.exports =  {"tooltip":"Y_05slf","box-content":"xZqc_Ec","boxContent":"xZqc_Ec","box":"n8k5Ydl"};